import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addProduct } from 'slice/productSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from "react-select";
import useCities from "hooks/useCities";

const AddProduct = () => {
    const [formData, setFormData] = useState({
        name: '',
        image: '',
        price: '',
        long_description: ''
    });
    const { cityOptions } = useCities();
    const handleCityChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            city: selectedOption ? selectedOption.value : "",
        }));
    };
    const nevigate = useNavigate()
    const dispatch = useDispatch()
    const { loading } = useSelector((state) => state.product);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));

    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        for (const key in formData) {
            formDataToSend.append(key, formData[key]);
        }

        try {
            dispatch(addProduct(formDataToSend))
            toast('Product added successfully!')
            nevigate('/products')
        } catch (error) {
            console.error('There was a problem adding the product:', error.message);
        }
    };


    return (
        <>
            <div className='container-fluid mt-5'>
                <div className='mainheadig mx-4'>
                    <h4 className='text-white font-weight-bold '>Add Service</h4>
                </div>
                <form onSubmit={handleSubmit} className='form-style'>
                    <div className='row mx-4 mt-5' >
                        <div className='col-sm-4 mt-2'>
                            <label htmlFor='productName' className='lables'>Name</label>
                            <input type='text' id='productName' name='name' defaultValue={formData.name} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-4 mt-2'>
                            <label htmlFor='productName' className='lables'>Price</label>
                            <input type='number' id='productName' name='price' defaultValue={formData.price} className='form-control' onChange={handleChange} />
                        </div>
                        <div className='col-sm-4 mt-2'>
                            <label htmlFor='productName' className='lables'>City</label>
                            <Select
                                id="city"
                                name='city'
                                options={cityOptions}
                                onChange={handleCityChange}
                                value={cityOptions.find(
                                    (option) => option.value === formData.city
                                )}
                                placeholder="Select or type city..."
                                isClearable
                                isSearchable
                            />
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='productName ' className='lables'>Description</label>
                            <textarea rows={5} name='long_description' defaultValue={formData.long_description} className='form-control' onChange={handleChange}></textarea>
                        </div>
                        <div className='col-sm-12 mt-4'>
                            <label htmlFor='productImage' className='lables'>Image</label>
                            <input type='file' id='productImage' name='image' className='form-control btn btn-primary' onChange={handleChange} />
                        </div>
                    </div>
                    <div className='mt-5 text-right mx-4 '>
                        <button className='btn btn-lg addbtn' disabled={loading}>Add</button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default AddProduct